var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import Cookies from 'js-cookie';
import { z } from 'zod';
import CompanyStore from 'stores/CompanyStore/store';
/** The backend sends Retry-After 30 on both retryable 503s. */
export var DEFAULT_RETRY_AFTER_MS = 30000;
/** A header that asks for longer than this is not taken at its word. */
export var MAX_RETRY_AFTER_MS = 300000;
/** The 503s the server marks as worth a later tap, with a Retry-After. */
var RetryLaterBody = z.object({
    reason: z.enum(['preflight_unavailable', 'rollout_unknown'])
});
/**
 * Retry-After as RFC 9110 §10.2.3 allows it (Codex P2-a): whole seconds
 * ("0" means now) or an HTTP-date, the wait clamped to 0–300 s. A missing or
 * unreadable header is the default. Note: cross-origin, the browser hides
 * this header unless the API exposes it; the default then applies.
 */
var retryAfterMsOf = function (headers) {
    var raw = typeof headers === 'object' && headers !== null ?
        headers['retry-after'] :
        undefined;
    if (typeof raw !== 'string')
        return DEFAULT_RETRY_AFTER_MS;
    var value = raw.trim();
    var ms;
    if (/^\d+$/.test(value)) {
        ms = Number(value) * 1000;
    }
    else if (/[a-z]/i.test(value) && !Number.isNaN(Date.parse(value))) {
        ms = Date.parse(value) - Date.now();
    }
    else {
        return DEFAULT_RETRY_AFTER_MS;
    }
    return Math.min(Math.max(ms, 0), MAX_RETRY_AFTER_MS);
};
/** The typed refusals, each with the one HTTP status the backend sends it with. */
var REFUSAL_STATUS = {
    board_changed: 409,
    nudges_paused: 503,
    producer_excused: 409
};
var RefusalBody = z.object({
    reason: z.enum(['board_changed', 'nudges_paused', 'producer_excused', 'preflight_unavailable'])
});
var refusalOf = function (status, data) {
    var parsed = RefusalBody.safeParse(data);
    if (!parsed.success || parsed.data.reason === 'preflight_unavailable')
        return null;
    return REFUSAL_STATUS[parsed.data.reason] === status ? parsed.data.reason : null;
};
var retryLaterOf = function (status, data, headers) {
    if (status !== 503 || !RetryLaterBody.safeParse(data).success)
        return null;
    return { status: 'retry_wait', retryAfterMs: retryAfterMsOf(headers) };
};
var nudgeProducer = function (producerId) { return __awaiter(void 0, void 0, void 0, function () {
    var apiEndpoint, result, error_1, response, status_1, later, refusal;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                apiEndpoint = CompanyStore.getApiEndpoint();
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios.post("".concat(apiEndpoint, "/api/v1/coach/nudge"), { producer_id: producerId }, { headers: { sbbsession: Cookies.get('sbb_sess') } })];
            case 2:
                result = _b.sent();
                return [2 /*return*/, { status: ((_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.success) === true ? 'sent' : 'error' }];
            case 3:
                error_1 = _b.sent();
                response = error_1 === null || error_1 === void 0 ? void 0 : error_1.response;
                status_1 = response === null || response === void 0 ? void 0 : response.status;
                if (status_1 === 429)
                    return [2 /*return*/, { status: 'rate_limited' }];
                later = retryLaterOf(status_1, response === null || response === void 0 ? void 0 : response.data, response === null || response === void 0 ? void 0 : response.headers);
                if (later !== null)
                    return [2 /*return*/, later];
                refusal = refusalOf(status_1, response === null || response === void 0 ? void 0 : response.data);
                if (refusal !== null)
                    return [2 /*return*/, { status: refusal }];
                console.warn('Coach nudge failed', error_1);
                return [2 /*return*/, { status: 'error' }];
            case 4: return [2 /*return*/];
        }
    });
}); };
export default nudgeProducer;
